<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-7">
            <table>
              <tr>
                <td>
                  <template v-if="getRoleId != 7">
                    <a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                  </template>
                </td>
                <td>
                  <flat-pickr @on-change="onChangeDate" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
                <td v-if="getRoleId == 1">
                  <a @click="syncData2()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Sync</a>

                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select :disabled="getRoleId == 17 || getRoleId == 22 || getRoleId == 1 || getRoleId == 31 || getRoleId == 33 ? false : true" name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <b-table class="table-custom" @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" :current-page="currentPage" :per-page="paginationLimit">
<!--          <template slot="pt_tier" slot-scope="data">-->
          <template v-slot:Cell(pt_tier)="data">
            <p v-if="data.item.pt_tier != 5">T{{data.item.pt_tier}}</p>
            <p v-else>T1</p>
          </template>
          <!-- <template slot="total_session_sold" slot-scope="data">
            {{data.item.pt_session_sold_new + data.item.pt_session_sold_renew}}
          </template> -->
<!--          <template slot="status" slot-scope="data">-->
          <template v-slot:cell(status)="data">
            <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
          </template>
        </b-table>
        <nav class="mt-20 mb-20">
          <b-pagination class="mb-0 justify-content-end" :total-rows="getRowCount(items)" :per-page="paginationLimit" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
        <!-- <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/> -->
      </div>
    </div>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'gallery',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'personal_trainer_id',
          label: 'Employee ID',
          sortable: false
        },
        {
          key: 'branch.name',
          label: 'Branch Name',
          sortable: false
        },
        {
          key: 'name',
          label: 'PT Name',
          sortable: false
        },
        {
          key: 'tier',
          label: 'Tier',
          formatter: (value, key, item) => {
            return item.personal_training_tier ? item.personal_training_tier.name : item.pt_tier
          },
          sortable: false
        },
        {
          key: 'pt_session_sold_new',
          label: 'PT Session Sold (New)',
          sortable: false
        },
        {
          key: 'pt_revenue_sold_new',
          label: 'PT Revenue Sold (Gross) (New) (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(Math.round(item.pt_revenue_sold_new)).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        {
          key: 'pt_comission_revenue_sold_new',
          label: 'PT Revenue Sold (Commision) (New) (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(Math.round(item.pt_comission_revenue_sold_new)).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        {
          key: 'pt_session_sold_renew',
          label: 'PT Session Sold (Renew)',
          sortable: false
        },
        {
          key: 'pt_revenue_sold_renew',
          label: 'PT Revenue Sold (Gross) (Renew) (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(Math.round(Math.round(item.pt_revenue_sold_renew))).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        {
          key: 'pt_comission_revenue_sold_renew',
          label: 'PT Revenue Sold (Commision) (Renew) (IDR)',

          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(Math.round(item.pt_comission_revenue_sold_renew)).toLocaleString('id-ID', {maximumFractionDigits:0})
          },
          sortable: false
        },
        {
          key: 'total_session_sold',
          label: 'Total Session Sold',
          formatter: (value, key, item) => {
            return parseInt(item.pt_session_sold_new) + parseInt(item.pt_session_sold_renew)
          },
          sortable: false
        },
        {
          key: 'total_session_revenue',
          label: 'Total Session Revenue (Gross) (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + (parseFloat(Math.round(item.pt_revenue_sold_new)) + parseFloat(Math.round(item.pt_revenue_sold_renew))).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          // sort 2
          sortable: false
        },
        {
          key: 'pos',
          label: 'POS',
          formatter: (value, key, item) => {
            return item.total_revenue_pos_1 == null || item.total_revenue_pos_2 == 0 ? '0': item.total_revenue_pos_1
          },
          sortable: false
        },
        {
          key: 'total_commision',
          label: 'Total Sold Commision (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + (parseFloat(Math.round(item.pt_comission_revenue_sold_new)) + parseFloat(Math.round(item.pt_comission_revenue_sold_renew))).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        {
          key: 'pt_service_package',
          label: 'PT Service Package',
          formatter: (value, key, item) => {
            return item.pt_service_package
          },
          sortable: false
        },
        {
          key: 'pt_service_free',
          label: 'PT Service Complimentary',
          formatter: (value, key, item) => {
            return item.pt_service_free
          },
          sortable: false
        },
        {
          key: 'pt_service',
          label: 'Total PT Service',
          sortable: false
        },
        {
          key: 'c1_txt',
          label: 'Commision(%)',
          sortable: false
        },
        {
          key: 'pha_service',
          label: 'PHA Service',
          sortable: false
        },
        {
          key: 'pt_service_revenue',
          label: 'PT Service Revenue (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(Math.round(item.pt_service_revenue)).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          //sort first
          sortable: false
        },
        {
          key: 'pt_service_commission_package_nett',
          label: 'PT Service Commision Package (IDR)',
          formatter: (value, key, item) => {
            return isNaN(parseFloat(Math.round(item.pt_service_comission_package_nett))) ? 'Rp. 0' : 'Rp. ' + parseFloat(Math.round(item.pt_service_comission_package_nett)).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          //sort first
          sortable: false
        },
        {
          key: 'pt_service_comission_free',
          label: 'PT Service Commision Complimentary (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(Math.round(item.pt_service_comission_free_nett)).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          //sort first
          sortable: false
        },
        {
          key: 'pt_service_comission',
          label: 'PT Service Commision (IDR)',
          formatter: (value, key, item) => {
            return item.pt_service_comission_nett == null ? 'Rp. 0' : 'Rp. ' + parseFloat(Math.round(item.pt_service_comission_nett)).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        // {
        //   key: 'gross_comission',
        //   label: 'Total Commision (Sold + Service) (Gross) (IDR)',
        //   formatter: (value, key, item) => {
        //     return 'Rp. ' + parseFloat(item.gross_comission).toLocaleString('id-ID', {maximumFractionDigits:2})
        //   },
        //   sortable: false
        // },
        {
          key: 'nett_comission',
          label: 'Total Commision (Sold + Service) (Nett) (IDR)',
          formatter: (value, key, item) => {
            return item.nett_comission == null ? 'Rp. 0': 'Rp. ' + parseFloat(Math.round(item.nett_comission)).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        }
      ],
      items: [],
      dataBranch: [],
      branch_id: Auth.Session.get().paradigm_branch_id,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        // onChange: this.onChange
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    onChangeDate(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    parseCurrency(value) {
      // var newValue = value.toFixed()
      return value.toLocaleString('id-ID', {maximumFractionDigits:0})
    },
    openPage (event) {
      this.$router.push(event)
    },
    editGallery (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'compro/v1/img/gallery/' + value
    },
    exportReport() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/pt_report/best_of_the_best?start_date='+dates[0]+'&end_date='+dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      // if (Auth.Session.get().paradigm_role == 7) {
      //   url += '&pt_id=' + this.getID
      // }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'PT Best of The Best (Report) '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    changeBranch(event) {
      this.loadingActive = true
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/pt_report/best_of_the_best?sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start_date=' + dates1[0]
      + '&end_date=' + dates1[1]

      if (event != null) {
        url += '&branch_id=' + event
      }



      axios.get(url).then(response => {
        this.loadingActive = false
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount

        if (Number(Auth.Session.get().paradigm_role) == 7 || Number(Auth.Session.get().paradigm_role) == 21) {
          // pt_id = Auth.Session.get().paradigm_id
          let filter = this.items.filter(item => item.personal_trainer_id == Auth.Session.get().paradigm_id)
          this.items = filter
          this.totalPage = 1
        }
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    syncData2() {
      // console.log('test', JSON.stringify(this.items))
      this.loadingActive = true
      let dates1 = this.exportDates.split(' to ')

      let url = 'crm/v1/pt_report/best_of_the_best/sync?start_date=' + dates1[0]
      axios({
        method: 'post',
        url: url,
        data: {data: this.items}
      }).then(response => {
        this.loadingActive = false
        this.$swal('Sync', 'You successfully Sync Data', 'success')
        this.changeBranch(this.branch_id)
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    syncData() {
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/pt_report/best_of_the_best/sync?sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start_date=' + dates1[0]
      + '&end_date=' + dates1[1]

      if (this.branch_id) {
        url += '&branch_id=' + this.branch_id
      }

      axios.get(url).then(response => {
        this.$swal('Sync', 'You successfully Sync Data', 'success')
        this.changeBranch(this.branch_id)
      }).catch(error => {
        console.log('error', error)
      })
    },
    async fetchData() {
      console.log(Auth.Session.get().paradigm_role)
      // only admin
      if(Number(Auth.Session.get().paradigm_role) != 1 ) {
        // pt_service_package
        // pt_service_free
        // pt_service_commission_package
        // pt_service_comission_free

        let fields = this.fields.filter(field => field.key != 'c1_txt')

        fields = fields.filter(field => field.key != 'pt_service_package')
        fields = fields.filter(field => field.key != 'pt_service_free')
        fields = fields.filter(field => field.key != 'pt_service_commission_package')
        fields = fields.filter(field => field.key != 'pt_service_comission_free')

        this.fields = fields
      }

      await axios.get('fitness/v1/branch/').then(response => {
          this.dataBranch = response.data.data.rows
          if (Auth.Session.get().paradigm_id == 1061857 || Auth.Session.get().paradigm_id == 1061825 || Auth.Session.get().paradigm_id == 1061850 || Auth.Session.get().paradigm_id == 1061816 || Auth.Session.get().paradigm_id == 1061848 || Auth.Session.get().paradigm_id == 1061968) {
            let filter = this.dataBranch.filter(item => item.id == Number(Auth.Session.get().paradigm_branch_id))
            this.dataBranch = filter
            this.branch_id = Number(Auth.Session.get().paradigm_branch_id)
          }

          // filter role
          // disabled for SPV PT S
          if (Auth.Session.get().paradigm_role == 31) {
            let filter = this.dataBranch.filter(item => item.id == Number(Auth.Session.get().paradigm_branch_id))
            this.dataBranch = filter
            this.branch_id = Number(Auth.Session.get().paradigm_branch_id)
          }
        }).catch(error => {
          console.log('error', error)
        })

      this.changeBranch(this.branch_id)
      // let dates1 = this.exportDates.split(' to ')

      // let url = 'crm/v1/pt_report/best_of_the_best?sorting=' + this.sortBy
      //   + '&limit=' + this.paginationLimit
      //   + '&sorting_type=' + this.sortType
      //   + '&keyword=' + this.searchData
      //   + '&start_date=' + dates1[0]
      //   + '&end_date=' + dates1[1]

      //   if (this.branch_id != null) {
      //     url += '&branch_id=' + this.branch_id
      //   }

      //   axios.get(url).then(response => {
      //     this.items = response.data.data.rows
      //     // this.totalPage = (response.data.data.rows).length
      //     this.totalPage = response.data.meta.pageCount
      //   }).catch(error => {
      //     console.log('error', error)
      //   })


      // if(Auth.Session.get().paradigm_role == 7){
      //   let url = 'crm/v1/pt_report/best_of_the_best?pt_id=' + Auth.Session.get().paradigm_id
      //     + '&sorting=' + this.sortBy
      //     + '&sorting_type=' + this.sortType
      //     + '&keyword=' + this.searchData
      //     + '&start_date=' + dates1[0]
      //     + '&end_date=' + dates1[1]

      //   axios.get(url).then(response => {
      //     this.items = response.data.data.rows
      //     this.totalPage = (response.data.data.rows).length
      //   }).catch(error => {
      //     console.log('error', error)
      //   })
      // } else {
      //   let url = 'crm/v1/pt_report/best_of_the_best?sorting=' + this.sortBy
      //   + '&limit=' + this.paginationLimit
      //   + '&sorting_type=' + this.sortType
      //   + '&keyword=' + this.searchData
      //   + '&start_date=' + dates1[0]
      //   + '&end_date=' + dates1[1]

      //   if (this.branch_id != null) {
      //     url += '&branch_id=' + this.branch_id
      //   }

      //   axios.get(url).then(response => {
      //     this.items = response.data.data.rows
      //     this.totalPage = (response.data.data.rows).length
      //   }).catch(error => {
      //     console.log('error', error)
      //   })

      //   axios.get('fitness/v1/branch/').then(response => {
      //     this.dataBranch = response.data.data.rows
      //   }).catch(error => {
      //     console.log('error', error)
      //   })
      // }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
